import React from 'react'

const href = 'http://www.styletheory.co'

export const BigLogo = props => (
  <a className='dn flex-l items-center h-100' href={href}>
    <img className='mw-100'
      style={{
        height: '20px',
        width: '240px',
      }}
      src={props.isOpaque ? 'assets/logo-black.png' : 'assets/logo.png'}
    />
  </a>
)

export const MediumLogo = props => (
  <a className='dn db-l h-100' href={href}>
    <img className='mw-100'
      style={{
        height: '16px',
        width: '192px',
      }}
      src={props.isOpaque ? 'assets/logo-black.png' : 'assets/logo.png'}
    />
  </a>
)

export const SmallLogo = props => (
  <a className='flex items-center dn-l'
    style={{
      height: '16px',
      width: '192px',
    }}
    href={href}
  >
    <img className='mw-100' src={props.isOpaque ? 'assets/logo-black.png' : 'assets/logo.png'} />
  </a>
)

export default {
  Big: BigLogo,
  Medium: MediumLogo,
  Small: SmallLogo,
}
